<template>
  <div>
    <router-link to="/about"><cq-menubarleft menubarbtn="ABOUT" curvedfront=true></cq-menubarleft></router-link>
    <router-link to="/manan-vasa"><cq-menubarleft menubarbtn="MANAN VASA"></cq-menubarleft></router-link>
    <router-link to="/gain-meter"><cq-menubarleft menubarbtn="GAIN METER"></cq-menubarleft></router-link>
    <!-- <router-link to="/free-tools"><cq-menubarleft menubarbtn="FREE TOOLS" last=true curvedend=true></cq-menubarleft></router-link> -->
    <a href="http://productivity-shastra.mananvasa.com/" target="_blank"><cq-menubarleft menubarbtn="START PRODUCTIVITY SHASTRA"></cq-menubarleft></a>
    <a href="http://colloquium.mananvasa.com/" target="_blank"><cq-menubarleft menubarbtn="START COLLOQUIUM" last=TRUE curvedend=true></cq-menubarleft></a>
  </div>
</template>

<script>
import CQMenubarRight from "./CQMenubarRight.vue";
export default {
  name: 'CQMenubarLeft',
  components: {
    'cq-menubarleft': CQMenubarRight
  }
}
</script>

<style>

</style>

